import { AuthStep } from '@/features/authorization/types/step';

export const getPreviousStep = (
  currentStep: AuthStep = AuthStep.PROFILE
): AuthStep => {
  switch (currentStep) {
    case AuthStep.GEO_AREA: {
      return AuthStep.PROFILE;
    }
    case AuthStep.TERMS: {
      return AuthStep.GEO_AREA;
    }
    default: {
      return AuthStep.PROFILE;
    }
  }
};

export const getNextStep = (
  currentStep: AuthStep = AuthStep.PROFILE
): AuthStep => {
  switch (currentStep) {
    case AuthStep.PROFILE: {
      return AuthStep.GEO_AREA;
    }
    case AuthStep.GEO_AREA: {
      return AuthStep.TERMS;
    }
    default: {
      return AuthStep.PROFILE;
    }
  }
};
